import server from './config';
import store from './store';
import axios from 'axios';
import VueJwtDecode from 'vue-jwt-decode';

const initJimoScript = async () => {
  window.jimo = [];

  const s = document.createElement('script');

  s.type = 'text/javascript';
  s.async = true;
  s.src = 'https://undercity.usejimo.com/jimo-invader.js';
  window.JIMO_PROJECT_ID = '00bee95c-16bd-4498-85f1-8f0bf45dbd84';
  document.getElementsByTagName('head')[0].appendChild(s);

  return new Promise((resolve, reject) => {
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error('Failed to load Jimo SDK'));
  });
};

const initJimoAttributes = attributes => {
  window.jimo.push([
    'do',
    'identify',
    [
      attributes.sso_id,
      () => {
        window.jimo.push(['set', 'user:name', [attributes.t_user_name]]);
        window.jimo.push(['set', 'user:attributes', [attributes]]);
      },
    ],
  ]);
};

const getUserData = async () => {
  try {
    const url = `${server.endPoint}/users/user-profile`;
    const { data } = await axios.get(url);
    if (data.status_code === 200) {
      //
      const {
        consultant,
        user,
        isa,
        icsa,
        t_role,
        sso_company_id,
        t_user_name,
        t_company_size,
        t_company_name,
        t_company_id,
        t_company_status,
        t_company_industry,
        t_company_go_live_status,
        t_package,
        t_perf_review_role,
        t_performance_review_package,
        t_performance_review_module,
        t_talent_management_module,
        is_quota_based,
        is_action_restricted,
        t_submit_review,
        t_update_goal_progress,
        quota,
        packages,
      } = data?.contents || {};
      localStorage.setItem('userProfile', JSON.stringify(data?.contents));

      store.commit('SET_USER_DATA', { ...user, isa, icsa, t_role, t_company_name, t_company_id }); // set userData, because user-profile is more complete than token
      if (consultant?.length) store.dispatch('storeCompaniesData', consultant); // set company list for navbar
      store.commit('SET_QUOTA_BASED', { is_quota_based, is_action_restricted, quota });
      const isKakiTanganValue = packages.includes('CP-TALENTA-2025-0003');
      store.commit('setIsKakiTangan', isKakiTanganValue);
      // Hide Intercom if isKakiTangan is true, otherwise show it
      store.commit('setIsHideIntercom', isKakiTanganValue);

      if (window.jimo) return;

      // init jimo script regardless what user role is
      await initJimoScript();
      // initialize/send data to jimo in FE only if logged user is a SA and consultant or is SA
      if (icsa || isa) {
        const jimoAttributes = {
          sso_id: user.sso_id,
          t_perf_review_role,
          t_user_name,
          t_user_id: user.id,
          t_role,
          t_company_id: user.company_id,
          sso_company_id,
          t_company_size,
          t_company_name,
          t_company_status,
          t_company_industry,
          t_company_go_live_status: t_company_go_live_status.toString(),
          t_package,
          t_performance_review_package,
          t_performance_review_module: t_performance_review_module.toString(),
          t_talent_management_module: t_talent_management_module.toString(),
          t_email: user.email,
          t_phone_number: user.mobile_phone || user.phone,
          user_origin: 'talenta',
          t_submit_review: t_submit_review.toString(),
          t_update_goal_progress: t_update_goal_progress.toString(),
        };
        initJimoAttributes(jimoAttributes);
      }
    }
  } catch (e) {
    console.log('Failed to get user data');
  }
};

const initMoengage = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '/moengage.js';
  script.async = true;
  document.head.appendChild(script);
};

function doesMoengageExist(src) {
  return !!document.querySelector(`script[src="${src}"]`);
}

const setSDKData = (token, consultantData = null) => {
  const tokenData = VueJwtDecode.decode(token);
  const { user } = tokenData;
  const isActiveCompany = consultantData ? consultantData.is_active_company : tokenData.is_active_company;
  const companyId = consultantData ? consultantData.company_id : user.company_id;

  if (!doesMoengageExist('/moengage.js') && isActiveCompany) initMoengage();

  const interval = setInterval(() => {
    if (window.Moengage) {
      const moeId = `${user.id}_${companyId}`;
      window.Moengage.add_unique_user_id(moeId).then(() => {
        window.Moengage.add_email(user.email);
        window.Moengage.add_first_name(user.first_name);
        window.Moengage.add_last_name(user.last_name);
      });
      window.Moengage.track_event('LOGIN', {
        USER_ID: user.id,
        COMPANY_ID: companyId,
      });
      clearInterval(interval);
    }
  }, 500);

  setTimeout(() => {
    clearInterval(interval);
  }, 5000);

  getUserData();
};

export default setSDKData;
